import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';
import rgba from 'assets/theme/function/rgba';
import { breakpoints } from 'assets/theme/base/breakpoints';

const { primary, common } = colors;
const { fontWeightRegular, size } = typography;

const inputLabel = {
    styleOverrides: {
        root: {
            fontSize: size.sm,
            fontWeight: fontWeightRegular,
            color: common.white,

            [breakpoints.down('md')]: {
                fontSize: size.sm,
            },

            [breakpoints.down('sm')]: {
                fontSize: size.xs,
                transform: 'translate(14px, 14px) scale(1)',
            },

            '&.Mui-error': {
                color: common.white,
            },

            '&.Mui-disabled': {
                color: rgba(common.white, 0.3),
            },
        },

        shrink: {
            color: primary.main,

            '&.Mui-focused': {
                color: primary.main,
            },

            [breakpoints.down('sm')]: {
                fontSize: size.xs,
                transform: 'translate(14px, -7px) scale(0.75)',
            },
        },
    },
};

export default inputLabel;
